import { LangFile } from './'
const Texts:LangFile = {
    noData: "No Data",
    homepagetitle: "Home Page",
    desktopPlatform: "Desktop Platform",
    operationsPlatform: "Operations Platform",
    required: "Required",
    optional: "Optional",
    overview: "Overview",
    default: "Default",
    select: "Select",
    action: "Action",
    changes: "Changes",
    unknown: "Uknown",
    search: "Search",
    filterBy: "Filter By",
    yes: "Yes",
    no: "No",
    from: "From",
    to: "To",
    settings: "Settings",
    
    languages: {
        en: "English",
        dk: "Dansk",
        es: "Español",
        de: "Deutsch",
        ma: "Mandarin"
    },

    user: {
        user: "User",
        userName: "User Name",
        userInformations: "User Informations",
        userId: "User-ID",
        firstName: "First Name",    
        lastName: "Last Name",
        phone: "Phone",
        email: "Email",
        password: "Password",
        repeatPassword: "Repeat Password",
        country: "Country",
        address: "Address"
    },
    
    farm: {
      farmName: "Farm Name",
      city: "City",
      street: "Street",
      vat: "Vat",
    },
    
    buttons: {
        goBackBtn: "Go Back",
        createBtn: "Create",
        cancelBtn: "Cancel",
        saveBtn: "Save",
        logOutBtn: "Logout",
        loginbtn: "Login",
        quickEntry: "Quick Entry",
        next: "Next",
        prev: "Previous",
        goToSiteList: "Go to Site List",
        details: "Details",
        edit: "Edit",
        add: "Add",
        remove: "Remove",
        view: "View",
        reset: "Reset",
        move: "Move",
        skip: "Skip",
        plan: "Plan",
        forNow: "For Now",
        startFeeding: "Start Feeding",
        standard: "Standard",
        discard: "Discard",
        selectAll: "Select All",
        deselectAll: "Deselect All"
    },

    cookie:{ 
        header:"Cookies",
        context:`Agrisys A/s use cookies for the following purposes:\n`+
        `1* To support the website's functionality, for example by remembering your settings regarding cookies, preferred languages, currencies, etc.\n`+
        `2* To perform statistical analysis of your use of the website, for example by measuring what type of content you are looking at and clicking on.\n`+
        `\n`+
        `By pressing “Accept all” you accept our use of cookies.\n`+
        `Else a minimun of cookies will be used required by the service to function, for example to manage login, and data fetching from the consys platfrom.`,
        accept:"Accept necessary",
        acceptAll:"Accept All"
    },

    loginFlow: {
        login: {
            header: "Welcome Back!",
            footerText: "Not registered yet?",
            create: "Create New User",
            error: "Failed to login",
            forgotPassword: "Forgot Password",
            resetPassword: "Reset Password"
        },
        forgotPassword: { // remember: whiteSpace: 'pre-wrap' on styling
          text:   "If there is no email assigned to the user name, please contact the support for further help!",
          text2:  "Please don't close this window before the reset process is done.",
            noEmail: "No email assigned?",
            contactSupport: "Contact support",
            error: "Username required"
        },
        resetPassword: {
            text:`A temporary code has been sent to your email. Please\n`+
            `write it below to create a new password`,
            temporaryCode: "Temporary code",
            newPassword: "New password",
            repeatPassword: "Repeat new password",
            createNewPassword: "Create new password",
            text2: "Didn't recieve a temporary code?",
            error: "Failed to create new password"
        },
        createUser: {
            header: "New User",
            error: "Failed to create user"
        },
        chooseSite: {
            header: "Choose Site",
            column1: "Farm Name",
            column2: "Manager",
            column3: "Column 3",
            column4: "Column 4"
        }
    },

    globalMenu: {
        home: "Home",
        dashboard: "Dashboard",
        kpi: "KPI",
        feedCurves: "Feed Curves",
        ComponentAlternatives: "Component Alternatives",
        mixtures: "Mixtures",
        silos: "Silos",
        siloSettings: "Silo Settings",
        animals: "Animals",
        animalGroups: "Animal Groups",
        reports: "Reports",
        logBook: "Logbook",
        globalSettings: "Settings"
    },
    global_subMenu: {
        animals:{
            animalsEdit: "Animals Edit"
        }
    },

    toolsMenu: {
        tools: "Tools",
        graphQl: "Graph Ql",
        xml: "xml",
        farms: "Farms",
        users: "Users"
    },
    tools_subMenu: {
        graphQl: {
            configurations: "Configurations",
            software: "Software"
        }
    },
    locationFeeder: {
        sections: {
            section: "Section",
            sectionNo: "Section Number",
            sections: "Sections",
            to: "To"
        },
        newSectionPopup: {
          newSection: "New Section",
          layout: "Layout",
          io: "I/O Boards",
          apply: "Apply",
          columns: "Columns (max limit 2)",
          rows: "Rows",
          firstPenNo: "First Pen No.",
          Order: "Order",
          asc: "Ascending",
          desc: "Descending",
          direction: "Direction",
          horizontal: "Horizontal",
          vertical: "Vertical",
          numberOfPens: "Number of Pens",
          tableViewDisclaimer: "Click on a pen to remove it or add it again.",
          penContent: "Pen Content",
          feederOnly: "Feeder Only", 
          water: "Water",
          activator: "Activator",
          pen: "Pen", 
          chooseIO: "Choose I/O Board",
          feederOutput: "Feeder Output",
          waterOutput: "Water Output",
          activatorInput: "Activator Input",
          lanController: "LAN Controller",
          remainingOutputs: "Remaining Outputs",
          remainingInputs: "Remaining Inputs"
        },
        sectionsPopup: {
            feedCorrections: "Current Feed Corrections",
        },
        penPopup: {
            pen: "Pen",
            activations: "Activations",
            lastActivation: "Last Activation",
            activator: "Activator",
            feeder: "Feeder",
            motor: "Motor",
            lastDays: "Last 10 days",
            inThisPen: "In This Pen",
            emptyPen: "Empty Pen",
            empty: "Empty",
            penValueHeaders: "Hold the mouse on a value to see column type",
            goToAnimalPage: "Go to animal page",
            feedKg: "Feed (Kg)",
            fedTotal: "Fed Total",
            feedConsumption: "Feed Consumption",
            addAnimalToPen: "Add animal to pen"
        },
        planSkip: {
            planSkip: "Plan Skip",
            plannedSkip: "Planned Skip",
            timeSpan: "Time Span",
            timeAmount: "Time Amount",
            startDate: "Start Date",
            endDate: "End Date",
            startTime: "Start Time",
            endTime: "End Time"
        },
        overView: {
            systemControls: "System Controls",
            start: "Start",
            stop: "Stop",
            calibrate: "Calibrate",
            systemOn: "Turn On",
            systemOff: "Turn Off",
            emptySystem: "Empty",
            systemStateRunning: "Running",
            systemStateEmptying: "Emptying",
            systemStateCalibrating: "Calibrating",
            systemStatePaused: "Paused"
        }
    },
    progressComponents: {
        inThisSystem: "In This System",
        animalsNo: "Number of Animals",
        currentProgress: "Current Progress"
    },
    feed: {
        feedPlan: {
            feedPlan: "Feed Plan",
            feedCurve: "Feed Curve",
            components: "Components",
            milestones: "Milestones",
            name: "Name",
            readyComponent: "Ready",
            priority: "Priority",
            ds: "DS",
            energy: "Energy",
            protein: "Protein",
            day: "Day",
            milestone: "Milestone"
        },
        feedCorrections: {
            feedCorrection: "Feed Correction",
            increased: "Increased",
            decreased: "Decreased",
            disabled: "Disabled",
            active: "Active",
            skipFeeding: "Skip Feeding",
            feeding: "Feeding",
            noSkip: "No planned feed skip"
        },
        remaining: {
            today: "Remaining today",
            yesterday: "Remaining Yesterday"
        },
        fed: {
            today: "Fed Today",
            period: "Fed Last Period"
        },
        feedCurve: {
          addFeedcurve: "Add Feed Curve",
          createFeedCurve: "Create Feed Curve",
          createFeedCurveFromScratch: "Start a new feed curve from scratch",
          copyFeedcurve: "Copy Feed Curve",
          deleteFeedcurve: "Delete Feed Curve",
          feedcurveName: "Feed Curve Name",
          fromFeedcurve: "From Feed Curve",
          newFeedcurve: "New Feed Curve",
          spreading: "Spreading",
          corrections: "Corrections",
          watchFeedcurve: "Watch Feed Curve",
          emptyFeedcurve: "Press the edit button to start configuring the feed curve.",
          noFeedcurve: "No feed curve found"
        },
        settings: {
          feedSpeed: "Feed Speed (g/min)",
          maxAmount: "Max Period Amount (kg)",
          remaining: "Remaining Feed",
          stimoli: "Feed Stimoli",
          addStimoli: "Add Stimoli",
          singleStimoli: "Single Stimoli",
          repeatStimoli: "Repeat Stimoli",
          minutesApart: "minutes Apart",
          noStimoli: "No Stimoli",
          pass: "Pass to next period",
          toPass: "Max KG to pass",
          doNotPass: "Do not pass to next period",
          noComponents: "No Feed Components Found"
        },
    },
    units: {
        total: "Total",
        kg: "KG",
        mA: "mA",
        pct: "pct",
        g: "g",
        min: "min",
        farrowed: "Farrowed",
        minutAgo: "Minut Ago",
        minutesAgo: "Minutes Ago",
        hour: "Hour",
        hours: "Hours",
        hourAgo: "Hour Ago",
        hoursAgo: "Hours Ago",
        timesToday: "Times Today",
        timeToday: "Time Today",
        capacity: "Capacity",
        days: "Days",
        imperial: "Imperial",
        metric: "Metric",
        percentage: "Percentage"
    },
    attentions: {
        attentions: "Attentions",
        attention: "Attention",
        attentionType: "Attention Type",
        problem: "Problem",
        problems: "Problems",
        warning: "Warning",
        warnings: "Warnings",
        systemAlert: "System Alert",
        systemGood: "System Running",
        systemNeutral: "System Off",
        systemWarning: "System Warning",
        goToSystem: "Go To System"
    },
    reports: {
      report: "Report",
      farrowing: "Farrowing",
      farrowingsToday: "Farrowings Today",
      farrowed: "Animals Farrowed",
      template: "Template",
      addTemplate: "Add Template",
      copyTemplate: "Copy Template",
      newTemplate: "New Template",
      createNewReport: "Start a new report from scratch",
      noReportFound: "No report found",
      noDataParameterFound: "No data parameter found",
      noFilterParameterFound: "No filter parameter found",
      dataLevel: "Data Level",
      filterParameter: "Filter Parameter",
      dataParameter: "Data Parameter",
      archiveReport: "Archive Report",
      unArchiveReport: "Unarchive Report",
      saveAsTemplate: "Save as Template",
      archive: "Archive",
      archivedReport: "Archived Report",
      noStartDateFound: "No Start Date Found",
      noEndDateFound: "No End Date Found",
      reportName: "Report Name",
      newReport: "New Report",
      fromTemplate: "From Template",
      showInReport: "Show in Report",
      filterByNumber: "Report Number",
      filterByName: "Report Name Alphabetical"
    },
    settingsPages: {
      globalSettings: {
        userSettings: "User Settings",
        farmSettings: "Farm Settings",
        userManagement: "User Management",
        timeZone: "Time Zone",
        units: "Units",
        feedDayStart: "Feed Day Start",
        newMilestone: "New Milestone"
      },
      locationFeederSettings:{
        dailyRotation: "Daily rotation",
        dailyRotationDisclaimer: "NB: If the system is turned off a daily rotation will make sure to maintain the motor.",
        feedInSilos: "Feed in Silos",
        attentionLimit: "Lower Attention Limit",
        inputOutputConnections: "Input/Output Connections",
        feedSpeed: "Feed Speed",
        minimumFeedSpeed: "Minimum Feed Speed (g/min)",
        maximumFeedSpeed: "Maximum Feed Speed (g/min)",
        on: "On",
        off: "Off"
      }
    },
  animalPages:{
    animalGroups: {
      group: "Group",
      animalId: "Number of Animals",
      createGroup: "Create Group",
      newGroup: "New Group",
      groupName: "Group Name",
    },
    animal: {
      animal: "Animal",
      animalId: "Animal No.",
      latestMilestone: "Curr. milestone",
      milestoneDay: "Curr. milestone day",
      responderNo: "Responder No.",
      location: "Location",
      lifeNo: "Life No.",
      condition: "Condition",
      group: "Group",
      animalType: "Animal Type",
      totalCycleDay: "Total Cycle Day",
      newAnimal: "New Animal",
      noAnimal: "No Animals Selected",
      feedBalance: "Feedbalance",
      birthDate: "Birth Date",
      basicInfo: "Basic Info",
      noAnimalSelected: "No animal selected",
      remainingToday: "Remaining today",
      remainingYesterday: "Remaining yest.",
      feed: "Feed",
      marking: "Marking",
      events: "Events",
      eventName: "Event Name",
      eventDate: "Event Date",
      eventNotes: "Event Notes",
      noTimeline: "No Timeline"
    }
  }
}
export default Texts